// @flow

import React from 'react'
import Link from '@/components/Link'
import { ButtonStyles } from '@/styles/shared'

export default props => <button css={ButtonStyles} {...props} />

export const LinkButton = props => <Link css={ButtonStyles} {...props} />
